import { render, staticRenderFns } from "./SendMessageCompose.vue?vue&type=template&id=ec50e28e&"
import script from "./SendMessageCompose.vue?vue&type=script&lang=js&"
export * from "./SendMessageCompose.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageCompose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports